<!--mzjzlc.vue  门诊就诊流程-->
<template>
  <div class="mzjzlc-all-box">
    <div class="img-box">
      <img src="~@/assets/images/serviceGuide/mzjzlc.png" width="100%" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mzjzlc',
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.mzjzlc-all-box {
  padding: 10px;
}
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
}
</style>
